import { execute_generator } from './index'

const root = '/accounts'
const account_url = process.env.VUE_APP_API_ACCOUNT_URL

const user_root = '/users'
const users_url = process.env.VUE_APP_API_USER_URL

const address_route = '/accounts/addresses'

export const get_account = id => execute_generator(
    'GET', 
    { service: account_url, resource:`${root}/user/${id}` }
)

export const register_account = body => execute_generator(
    'PUT', 
    { service: account_url, resource:`${root}/complete` },
    body
)


export const get_dashboard = account_id => execute_generator(
    'GET',
    { service: account_url, resource:`${root}/dashboard/${account_id}`},
)

export const admin_methods = {

    get_account: account_id  => execute_generator('GET', { service: account_url, resource:`${root}/${account_id}` }),
    update_account: updated_account => execute_generator(
        'PUT', { service: account_url, resource:`${root}/${updated_account.id}` }, updated_account
    ),

    get_users: account_id => execute_generator('GET', { service: users_url, resource:`${user_root}/byacct/${account_id}` }),
    create_user: new_user => execute_generator('POST', { service: users_url, resource:`${user_root}/create` }, new_user),
    edit_user: updated_user => execute_generator(
        'PUT', { service: users_url, resource:`${user_root}/${updated_user.id}` }, updated_user
    ),
    delete_user: user => execute_generator(
        'DELETE', { service: users_url, resource:`${user_root}/${user.id}` }, user
    ),

    get_address: account_id => execute_generator('GET', { service: account_url, resource:`${address_route}/byacct/${account_id}` }),
    create_address: new_address => execute_generator('POST', { service: account_url, resource:`${address_route}/create` }, new_address),
    edit_address: update_address => execute_generator(
        'PUT', { service: account_url, resource:`${address_route}/${update_address.id}` }, update_address
    )

}
